import HeroBanner from "../components/HeroBanner";
import PopularSales from "../components/PopularSales";
import HighLights from "../components/HighLight";
import TopStories from "../components/TopStories";
import { heroapi, popularsales, topRatedSales, highlight, sneaker, story } from "../constents/Constents";
import {  useSelector } from "react-redux"; 
import Cart from "../components/Cart"

const Home = () => { 
    const { openCart } = useSelector((state) => state.Cart);  
   
    return (
        <> 
            <div className={` ${openCart ? "h-[100vh] z-50 opacity-100" : "opacity-0 "} w-screen fixed top-0 left-0 cart-container`}>
                <div className={`${openCart ? "bg-white h-full  absolute right-0 top-0 px-2  py-3" : "-right-96"} transition-all w-[100%] md:w-[450px] pr-5`}>
                   <Cart/>
                </div>
            </div>
            <div className="bg_color h-[65vh] absolute inset-0 w-auto opacity-100 z-10"></div>
            <section className=" relative z-20">
                <HeroBanner data={heroapi} />
            </section>
            <section className="relative z-20">
                <PopularSales data={popularsales} />
                <div className="flex items-center flex-col-reverse md:flex-row md:justify-between my-4 lg:my-6 gap-5">
                    <HighLights data={highlight} />
                </div>
            </section>
            <section>
                <PopularSales data={topRatedSales} isTrue={true} />
                <div className="flex flex-col-reverse items-center md:flex-row-reverse md:justify-between my-4 lg:my-6 gap-5">
                    <HighLights data={sneaker} />
                </div>
            </section>
            <section className="topStories max-w-[1400px] m-auto">
                <TopStories data={story} />
            </section>
        </>
    )
}
export default Home;